(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["product-card"] && !Shopify.designMode) return;
  try {
    function initAudienceCards(root = document) {
    root.querySelectorAll('[data-product-url="/products/nativ-wildform-pants"], [data-product-url="/products/glory-club-barrel-washed-sweatpant"]').forEach((card) => {
      const panel = card.closest('[data-featured-audience-panel="women"]');
      if (!panel || card.dataset.audienceInitialized) return;
      card.dataset.audienceInitialized = 'true';
      card.dataset.cardAudience = 'women';
      const swatch = card.querySelector('[data-card-swatch]');
      if (swatch) selectCardColor(swatch);
    });
  }
  document.addEventListener('DOMContentLoaded', () => initAudienceCards());
  document.addEventListener('shopify:section:load', (event) => initAudienceCards(event.target));

  function cardMediaKey(src) {
    return String(src || '').replace(/^https?:/, '').split('?')[0];
  }
  function resolveCardColorMedia(product, color, audience = '') {
    const normalize = (text) => String(text || '').toLowerCase().replace(/[^a-z0-9]+/g, ' ').trim();
    const optionIndex = product.options.findIndex((option) => /^(color|colour)$/i.test(option.name));
    const colors = product.options[optionIndex]?.values || [];
    const images = product.media.filter((media) => media.media_type === 'image');
    const variants = product.variants.filter((variant) => variant.options[optionIndex] === color);
    const variant = variants.find((item) => item.available) || variants[0];
    if (!variant || !images.length) return null;
    const aliases = { purple: ['pale lilac', 'lavender'], gray: ['grey'] };
    const describe = (media) => normalize(`${String(media.alt || '').replace(product.title, '')} ${String(media.src || '').split('/').pop().split('?')[0]}`);
    // Longest color name wins: "Light Pink" must not be mistaken for "Pink".
    const colorOf = (media) => {
      const text = ` ${describe(media)} `;
      const matches = colors.flatMap((name) => [normalize(name), ...(aliases[normalize(name)] || [])]
        .filter((term) => text.includes(` ${term} `)).map((term) => ({ name, length: term.length })));
      matches.sort((a, b) => b.length - a.length);
      return matches[0]?.name;
    };
    const matched = images.filter((media) => colorOf(media) === color);
    const isBack = (media) => /\b(back|rear)\b/.test(describe(media));
    const isSide = (media) => /\b(side|profile)\b/.test(describe(media));
    const isFront = (media) => /\b(front|hero)\b/.test(describe(media));
    const model = (media) => describe(media).match(/\b(female|male)\b/)?.[0];
    const preferred = matched.filter((media) => model(media) === (audience === 'women' ? 'female' : audience === 'men' ? 'male' : ''));
    const primary = preferred.find(isFront) || preferred[0] || matched.find(isFront) || matched[0];
    if (primary) {
      const alternatives = matched.filter((media) => media !== primary);
      const sameModel = alternatives.filter((media) => !model(primary) || model(media) === model(primary));
      const pool = sameModel.length ? sameModel : alternatives;
      return { primary, secondary: pool.find(isBack) || pool.find(isSide) || pool[0] || null, variant };
    }
    if (colors.length === 1) {
      return { primary: images[0], secondary: images.slice(1).find(isBack) || images[1] || null, variant };
    }
    const source = variant.featured_image?.src || variant.featured_media?.preview_image?.src;
    const index = images.findIndex((media) => cardMediaKey(media.src) === cardMediaKey(source));
    if (index < 0) return null;
    const next = images[index + 1];
    // Catalog mockups are front/back pairs. Never cross another variant's image boundary.
    const belongsElsewhere = next && product.variants.some((item) =>
      item.options[optionIndex] !== color && cardMediaKey(item.featured_image?.src) === cardMediaKey(next.src));
    const nextColor = next && colorOf(next);
    const secondary = next && !belongsElsewhere && (!nextColor || nextColor === color) ? next : null;
    return { primary: images[index], secondary, variant };
  }
  const cardProductRequests = new Map();
  const cardSelections = new WeakMap();
  function loadCardProduct(card) {
    const url = `${card.dataset.productUrl}.js`;
    if (!cardProductRequests.has(url)) {
      cardProductRequests.set(url, fetch(url, { headers: { Accept: 'application/json' } })
        .then((response) => {
          if (!response.ok) throw new Error('Product images unavailable');
          return response.json();
        }).catch((error) => { cardProductRequests.delete(url); throw error; }));
    }
    return cardProductRequests.get(url);
  }
  function cardImageUrl(media) {
    const url = new URL(media.src, window.location.origin);
    url.searchParams.set('width', '900');
    return url.href;
  }
  function preloadCardImage(media) {
    return new Promise((resolve, reject) => {
      const image = new Image();
      image.onload = () => resolve(image.src);
      image.onerror = () => reject(new Error('Image unavailable'));
      image.src = cardImageUrl(media);
    });
  }
  async function selectCardColor(button) {
    const card = button.closest('[data-product-card]');
    const request = {};
    cardSelections.set(card, request);
    card.setAttribute('aria-busy', 'true');
    const status = card.querySelector('[data-card-status]');
    if (status) status.textContent = `Loading ${button.dataset.color} photos`;
    try {
      const product = await loadCardProduct(card);
      const audience = card.dataset.cardAudience || card.closest('[data-featured-audience-panel]')?.dataset.featuredAudiencePanel || '';
      const media = resolveCardColorMedia(product, button.dataset.color, audience);
      if (!media) throw new Error('No matching color photo');
      const [primarySrc, secondarySrc] = await Promise.all([
        preloadCardImage(media.primary),
        media.secondary ? preloadCardImage(media.secondary).catch(() => null) : Promise.resolve(null)
      ]);
      if (cardSelections.get(card) !== request) return;
      const primary = card.querySelector('.product-card__image--primary');
      const wrap = card.querySelector('.product-card__image-wrap');
      if (!primary || !wrap) throw new Error('Product preview unavailable');
      let secondary = card.querySelector('.product-card__image--secondary');
      if (secondarySrc && !secondary) {
        secondary = primary.cloneNode();
        secondary.className = 'product-card__image product-card__image--secondary';
        wrap.append(secondary);
      }
      const updateImage = (image, src, alt) => {
        image.removeAttribute('srcset');
        image.removeAttribute('sizes');
        image.src = src;
        image.alt = alt || `${product.title} in ${button.dataset.color}`;
      };
      updateImage(primary, primarySrc, media.primary.alt);
      if (secondarySrc) updateImage(secondary, secondarySrc, media.secondary.alt);
      card.dataset.hasSecondary = String(Boolean(secondarySrc));
      card.dataset.selectedColor = button.dataset.color;
      card.querySelectorAll('[data-card-swatch]').forEach((swatch) => swatch.setAttribute('aria-pressed', String(swatch === button)));
      const label = card.querySelector('.product-card__color');
      if (label) label.textContent = button.dataset.color;
      card.querySelectorAll('.product-card__image-wrap, .product-card__quick-add, h3 a').forEach((link) => {
        const destination = new URL(button.href, window.location.origin);
        if (audience && ['nativ-wildform-pants', 'glory-club-barrel-washed-sweatpant'].includes(product.handle)) destination.searchParams.set('audience', audience);
        link.href = destination.href;
      });
      const price = card.querySelector('.price');
      if (price) {
        const current = price.querySelector('.price__current');
        if (current) current.textContent = button.dataset.price;
        price.querySelector('.price__compare')?.remove();
        price.classList.toggle('price--on-sale', Boolean(button.dataset.comparePrice));
        if (button.dataset.comparePrice) {
          const compare = document.createElement('span');
          compare.className = 'price__compare';
          compare.textContent = button.dataset.comparePrice;
          price.append(compare);
        }
      }
      const availability = card.querySelector('.product-card__availability');
      const badge = card.querySelector('.product-card__badge');
      if (availability && !/pre.?order/i.test(availability.textContent)) {
        availability.textContent = button.dataset.available === 'true' ? 'In stock' : 'Sold out';
        if (badge) badge.textContent = button.dataset.available === 'true' ? 'New' : 'Sold out';
      }
      if (!window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
        wrap.animate([{ opacity: 0.55 }, { opacity: 1 }], { duration: 180 });
      }
      if (status) status.textContent = `${button.dataset.color} photos shown`;
    } catch (error) {
      if (cardSelections.get(card) !== request) return;
      if (status) status.textContent = `Unable to load ${button.dataset.color} photos. Please try again.`;
    } finally {
      if (cardSelections.get(card) === request) card.removeAttribute('aria-busy');
    }
  }
  document.addEventListener('click', (event) => {
    const button = event.target.closest('[data-card-swatch]');
    if (!button || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
    event.preventDefault();
    selectCardColor(button);
  });
  document.addEventListener('keydown', (event) => {
    const button = event.target.closest('[data-card-swatch]');
    if (button && event.key === ' ') { event.preventDefault(); button.click(); }
  });
  document.addEventListener('pointerover', (event) => {
    const button = event.target.closest('[data-card-swatch]');
    if (button) loadCardProduct(button.closest('[data-product-card]')).catch(() => {});
  });
  if (document.readyState && document.readyState !== 'loading') initAudienceCards();
  } catch(e) { console.error(e); }
})();

})();
